<script lang="ts">
    import Icon from '@iconify/svelte'
    import { range } from 'lodash-es'

    import { gettext as _ } from 'hydria/services/gettext'

    interface Props {
        skip: number
        limit: number
        page?: number
        nItems: number
        // export let nLoaded: number
        loading: boolean
        // How many pages to show on each side of the current page.
        pageSurround?: number

        setSkip?: (n: number) => void
        setPage?: (n: number) => void
    }

    let { skip = $bindable(0), limit, page = 0, nItems, loading, pageSurround = 2, setSkip = (n: number) => {}, setPage = (n: number) => {} }: Props = $props()

    let ready = $state(false)
    let n = $state(2)

    let last: number = $state(0)

    let pageNums: Array<number> = $state([])
    // let firstPage: number = $state(0)
    // let lastPage: number = $state(0)

    // The start and end item numbers for the current page
    // e.g. for limit=10 and page=2: start = 11, end = 20
    let skipStart: number | undefined = $state()
    let skipEnd: number | undefined = $state()

    function calcValues(ready: boolean, skip: number, limit: number, page: number | undefined, nItems: number, loading: boolean) {
        let n: number

        let last: number

        let pageNums: number[]
        let firstPage: number
        let lastPage: number
        let skipStart: number | undefined
        let skipEnd: number | undefined

        ready = (skip != null || page != null) && limit != null && nItems != null && loading != null
        if (ready) {
            if (page != null && page) {
                skip = limit * (page - 1) + 1
            }
            n = Math.floor(skip / limit) + 1
            last = Math.floor((nItems - 1) / limit) + 1

            firstPage = Math.floor(n - pageSurround)
            lastPage = Math.ceil(n + pageSurround)

            if (firstPage < 1) {
                // shift to the right so that first becomes 1
                lastPage += 1 - firstPage
                firstPage = 1
                if (lastPage > last) lastPage = last
            } else if (lastPage > last) {
                // shift to the left
                firstPage -= lastPage - last
                lastPage = last
                if (firstPage < 1) firstPage = 1
            }
            if (lastPage < firstPage) {
                lastPage = firstPage
            }

            pageNums = range(firstPage, lastPage + 1)

            if (nItems) {
                skipStart = skip + 1
                skipEnd = skip + limit
                if (skipEnd > nItems) skipEnd = nItems
            } else if (nItems == 1) {
                skipStart = 1
                skipEnd = 1
                // } else {
                //     skipStart = 0
                //     skipEnd = 0
            }
            return setResult(ready, { n, last, firstPage, lastPage, pageNums, skipStart, skipEnd })
        }
        setResult(false)
    }

    function setResult(inReady: boolean, inp?: { n: number; last: number; firstPage: number; lastPage: number; pageNums: number[]; skipStart: number | undefined; skipEnd: number | undefined }) {
        ready = inReady

        if (ready && inp) {
            n = inp.n
            last = inp.last
            // firstPage = inp.firstPage
            // lastPage = inp.lastPage
            pageNums = inp.pageNums
            skipStart = inp.skipStart
            skipEnd = inp.skipEnd
        }
    }

    $effect(() => {
        calcValues(ready, skip, limit, page, nItems, loading)
    })

    function goto(pageNum: number) {
        if (loading) return
        setPage(pageNum)
        setSkip((pageNum - 1) * limit)
    }
</script>

<style>
    a,
    a:hover {
        text-decoration: none;
    }

    .page-list {
        display: flex;
        gap: 0.5rem;
        align-items: center;
    }
    .pl-loading {
        display: flex;
        justify-content: center;
    }
    /* .page-list > * {
        flex: 0 0 auto;
    } */
    .page-list > .text {
        flex: 1 0 0;
    }
</style>

{#if ready}
    <nav class="page-list" class:pl-no-results={!nItems}>
        <div class="text">
            <strong>
                {#if nItems > 1}{$_('{start}–{end} / {total} résultats', { start: skipStart, end: skipEnd, total: nItems })}
                {:else if nItems}{$_('Un résultat')}
                {:else}{$_('Aucun résultat')}
                {/if}
            </strong>
        </div>
        {#if loading}<div><div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div></div>{/if}
        {#if nItems}
            <nav aria-label={$_('Navigation par page')}>
                <ul class="pagination pagination-sm m-0">
                    <li class="page-item" class:disabled={loading || n < 2}>
                        <a
                            class="page-link"
                            href="/"
                            onclick={(e) => {
                                e.preventDefault()
                                goto(1)
                            }}><span aria-hidden="true"><Icon inline icon="mdi:chevron-double-left" /></span></a
                        >
                    </li>
                    <li class="page-item" class:disabled={loading || n < 2}>
                        <a
                            class="page-link"
                            href="/"
                            onclick={(e) => {
                                e.preventDefault()
                                goto(n - 1)
                            }}><span aria-hidden="true"><Icon inline icon="mdi:chevron-left" /></span></a
                        >
                    </li>
                    {#each pageNums as p}
                        <li class="page-item" class:disabled={loading} class:active={n == p}>
                            <a
                                class="page-link"
                                href="/"
                                onclick={(e) => {
                                    e.preventDefault()
                                    goto(p)
                                }}>{p}</a
                            >
                        </li>
                    {/each}
                    <li class="page-item" class:disabled={loading || n >= last}>
                        <a
                            class="page-link"
                            href="/"
                            onclick={(e) => {
                                e.preventDefault()
                                goto(n + 1)
                            }}><span aria-hidden="true"><Icon inline icon="mdi:chevron-right" /></span></a
                        >
                    </li>
                    <li class="page-item" class:disabled={loading || n >= last}>
                        <a
                            class="page-link"
                            href="/"
                            onclick={(e) => {
                                e.preventDefault()
                                goto(last)
                            }}><span aria-hidden="true"><Icon inline icon="mdi:chevron-double-right" /></span></a
                        >
                    </li>
                </ul>
            </nav>
        {/if}
    </nav>
{:else}
    <div class="pl-loading">
        <div class="spinner-border" role="status" aria-hidden="true"><span class="visually-hidden">{$_('Chargement…')}</span></div>
    </div>
{/if}
